export const audiences = [
  [
    "Women's refuges",
    "Private, coordinated bookings and stay extensions for women and children.",
    "FiHeart"
  ],
  [
    "Youth shelters",
    "Clear room status, caseworker handovers and daily departures.",
    "FiUsers"
  ],
  [
    "Temporary accommodation",
    "Track referrals, occupancy, extensions and financial records.",
    "FiHome"
  ],
  [
    "Multi-site services",
    "See location-by-location operational information in one place.",
    "FiGrid"
  ],
  [
    "Community support teams",
    "Automate forms, case records and compliance reporting without running rooms.",
    "FiClipboard"
  ],
  [
    "Small not-for-profits",
    "Simplify everyday administration with a system sized for your team.",
    "FiFeather"
  ]
];
export const problems = [
  [
    "Repeat entry",
    "Information is repeatedly copied from forms and spreadsheets into new records.",
    "Capture data once and use it where needed.",
    "FiCopy"
  ],
  [
    "Changing bookings",
    "Extensions and departures trigger many calls and manual checks.",
    "View stays, vacancies and follow-ups together.",
    "FiCalendar"
  ],
  [
    "Reporting pressure",
    "Teams manually compile recurring compliance and management reports.",
    "Generate configured reports from existing records.",
    "FiFileText"
  ],
  [
    "Disconnected updates",
    "Caseworkers and support staff need to check multiple tools.",
    "Share updates securely with clear responsibilities.",
    "FiUsers"
  ],
  [
    "Small-team workload",
    "Limited staff time is absorbed by avoidable admin.",
    "Remove repetitive steps without adding complexity.",
    "FiClock"
  ],
  [
    "Limited visibility",
    "Managers cannot quickly see outstanding work.",
    "Use concise dashboards and action lists.",
    "FiEye"
  ]
];
export const features = [
  [
    "Live availability",
    "View locations, buildings, available rooms, occupied stays and maintenance restrictions.",
    "FiGrid"
  ],
  [
    "Bookings & extensions",
    "Record referrals, check-in, checkout, extensions, allocations and booking notes.",
    "FiCalendar"
  ],
  [
    "Daily reconciliation",
    "See departures due, overdue stays, required extensions and unresolved follow-ups.",
    "FiCheckSquare"
  ],
  [
    "Referral coordination",
    "Record information about Link2home, DCJ, DVConnect, FIRST Canberra and other referring organisations when relevant.",
    "FiGitMerge"
  ],
  [
    "Caseworker notes",
    "Keep case references, authorised staff notes and timestamped activity with the relevant record.",
    "FiFileText"
  ],
  [
    "Access & audit history",
    "Configure individual access permissions and trace supported changes back to the user.",
    "FiShield"
  ],
  [
    "Finance & exports",
    "Prepare invoices, reports, CSV and Excel exports for accounting systems where required.",
    "FiBarChart2"
  ]
];
export const showcase = [
  [
    "Dashboard",
    "A clear daily view of occupancy, stays requiring action and operational priorities.",
    "See site-level activity",
    "Find urgent follow-ups faster",
    "Keep leadership informed"
  ],
  [
    "Room availability",
    "Simple location-by-location visibility into vacant, occupied and unavailable rooms.",
    "Reduce phone checks",
    "Coordinate placements",
    "Avoid double allocation"
  ],
  [
    "Booking management",
    "Review referrals, stay dates, extensions and checkout information in one workflow.",
    "Track every stay",
    "Record extensions",
    "Minimise double entry"
  ],
  [
    "Daily reconciliation",
    "Work through expected departures, overdue stays and extension requests.",
    "Find exceptions",
    "Record actions",
    "Export daily reports"
  ],
  [
    "Caseworker notes",
    "Structured, timestamped case updates with individual user access.",
    "Simplify handovers",
    "Find notes quickly",
    "Improve accountability"
  ],
  [
    "Compliance reports",
    "Generate configured occupancy, casework and operational reports on demand.",
    "Reduce manual compilation",
    "Use consistent reports",
    "Review before submission"
  ],
  [
    "Finance & exports",
    "Organised finance records and accounting-ready exports where configured.",
    "Simplify invoicing",
    "Export in agreed formats",
    "Improve record consistency"
  ]
];
export const faqs = [
  [
    "Getting started",
    "Do we need to operate a shelter to benefit?",
    "No. We also help family, community and support services automate Excel, Google Sheets, Google Forms, case records, approvals and compliance reporting. The goal is to reduce administrative workload, whether or not you manage rooms."
  ],
  [
    "Getting started",
    "We are a small organisation. Is this suitable for us?",
    "Yes. Small teams often carry a large administrative workload. We can start with one repetitive task, one report or a lightweight workflow rather than introducing a complex platform."
  ],
  [
    "Getting started",
    "Will we need to change how we operate?",
    "Not automatically. We first understand what is already working, then identify the steps that can be simplified or automated. A tailored solution should support staff rather than create extra work."
  ],
  [
    "Getting started",
    "Can we start with only one process?",
    "Absolutely. A reporting task, Excel workbook, form submission or booking approval is a valid starting point. Other processes can be considered later if they offer clear value."
  ],
  [
    "Getting started",
    "What happens in the initial walkthrough?",
    "A practical 15–20 minute tour using fictional sample data. We can show bookings, reconciliations, case records or spreadsheet automation, then discuss whether similar approaches would fit your work. There is no obligation."
  ],
  [
    "Accommodation",
    "Can we manage multiple shelters and locations?",
    "Yes. A configured system can organise locations, buildings, rooms, availability, stays and permissions across sites, while restricting information to authorised users."
  ],
  [
    "Accommodation",
    "Can staff see which rooms are available?",
    "A room board can show vacant, occupied, reserved or unavailable rooms, upcoming departures and maintenance notes. Visibility depends on the records and rules configured for your service."
  ],
  [
    "Accommodation",
    "How do new bookings and changes work?",
    "Booking forms can capture referral details, room selection, client and case references, arrival and departure dates, notes and status. Authorised staff can make changes through a traceable workflow."
  ],
  [
    "Accommodation",
    "Can we extend a booking or process a checkout?",
    "Yes. Stay extensions and checkouts can be handled as structured actions, including revised dates, reasons, approvals where required and an activity history."
  ],
  [
    "Accommodation",
    "How would daily reconciliation work?",
    "A daily view can present expected departures, overdue stays, extensions and outstanding follow-ups. Staff can record actions and export the report once the required rules are configured."
  ],
  [
    "Accommodation",
    "Can the system record referrals from Link2home and DCJ?",
    "Yes. You can record referrals, caseworker contacts, office details, reference numbers, actions and follow-up notes. This does not imply an official partnership or direct integration with Link2home or DCJ."
  ],
  [
    "Accommodation",
    "What about DVConnect or FIRST Canberra?",
    "The same configurable referral-record workflow can support the organisations your service works with, including DVConnect in Queensland and FIRST Canberra in the ACT. Direct technical integrations require separate approval and feasibility checks."
  ],
  [
    "Casework & compliance",
    "Can individual caseworkers have their own access?",
    "Yes. Role-based access can be designed so authorised employees see only the information appropriate to their role and responsibilities."
  ],
  [
    "Casework & compliance",
    "Can we store caseworker notes and references?",
    "A tailored case record can include references, structured notes, assigned workers, timestamps, follow-ups and relevant document references. Sensitive information needs an agreed secure handling approach."
  ],
  [
    "Casework & compliance",
    "Can we see who changed a booking or note?",
    "Audit and activity records can capture supported updates, including the user and time. The exact coverage is agreed during system design."
  ],
  [
    "Casework & compliance",
    "Can compliance reports be generated in one click?",
    "Yes, once the data structure, reporting rules and templates are configured, repeatable reports can be generated on demand. Staff should still review reports before formal submission."
  ],
  [
    "Casework & compliance",
    "Will this make us automatically compliant?",
    "No software can guarantee regulatory compliance. We can help improve record consistency, access controls and reporting workflows, but your organisation remains responsible for its legal and policy requirements."
  ],
  [
    "Excel & automation",
    "Do we have to stop using Excel or Google Sheets?",
    "No. Sometimes the best improvement is automating an existing spreadsheet or the processes around it. Other times a centralised application is more efficient. We recommend what is appropriate for your team."
  ],
  [
    "Excel & automation",
    "Can Google Forms feed directly into records and reports?",
    "Where technically possible, form submissions can be converted into structured records, notifications, follow-ups and scheduled or on-demand reports, reducing copy-and-paste administration."
  ],
  [
    "Excel & automation",
    "How much time could we save?",
    "BPA Solutions clients have reported saving 12–30 administrative hours weekly and up to 90% less manual effort in selected workflows. Outcomes vary depending on the process, volume and implementation."
  ],
  [
    "Excel & automation",
    "Can reporting drop from 30 minutes to under a minute?",
    "That outcome has been reported for selected client reporting workflows after automation. It is an example of what can be possible with structured data, not a guarantee for every report."
  ],
  [
    "Excel & automation",
    "Can we automate approvals, reconciliation and follow-ups?",
    "Yes. A workflow can track submitted requests, statuses, assignments, approvals, follow-ups and reconciliation actions, depending on how your organisation operates."
  ],
  [
    "Technology & security",
    "Can data be exported to accounting software?",
    "We can configure CSV, Excel or other agreed export formats to align with a platform's import requirements. Direct integrations depend on the software and accessible interfaces."
  ],
  [
    "Technology & security",
    "Can invoicing and receipts be included?",
    "Yes. Where relevant, the system can support invoice preparation, numbering, receipt records, payment summaries and exportable financial information."
  ],
  [
    "Technology & security",
    "How is sensitive client information handled?",
    "Security requirements are established before implementation and may include authentication, role-based access, audit logs, secure hosting, data retention rules and restricted data visibility. Specific compliance needs require an individual assessment."
  ],
  [
    "Technology & security",
    "What happens to existing spreadsheet data?",
    "We review the data, important fields, duplicate records and any quality issues. Appropriate information can be cleaned and imported through an agreed migration process, with secure handling of sensitive data."
  ],
  [
    "Technology & security",
    "Do staff need extensive training?",
    "The design emphasises familiar tasks, clear language, compact screens and straightforward actions. Training and supporting instructions can be tailored to staff needs."
  ],
  [
    "Websites & support",
    "Can BPA Solutions improve our website?",
    "Yes. We also design mobile-friendly websites, clearer enquiry forms and accessible content, with the option of connecting eligible online enquiries to internal workflows."
  ],
  [
    "Websites & support",
    "Can our website connect with the application?",
    "Potentially. Integration depends on the website platform, supported APIs and the information involved. We assess that before recommending any connection."
  ],
  [
    "Websites & support",
    "What support is available after launch?",
    "Support arrangements, enhancements and ongoing maintenance are discussed as part of the solution scope. We avoid assuming every organisation needs the same level of support."
  ]
];


// Purpose-led visitor FAQs. Keep questions grouped by the service a visitor
// is exploring, rather than mixing 30 topics into one long generic list.
export const faqGroups = [
  {
    id: 'accommodation', label: 'Accommodation',
    items: [
      ['We are a small organisation. Is this suitable for us?',
       'Yes. Small teams often carry a large administrative load. We work with teams ranging from around five people to larger services with 100 or more staff, depending on the requirements. We start with the repetitive tasks causing the most pressure, not the size of the organisation.'],
      ['Will we need to change the way we currently operate?',
       'We start by understanding your existing process. The goal is to preserve what already works and change only the steps that will genuinely reduce manual work, confusion or duplicated information.'],
      ['Can bookings, room availability, extensions and checkouts be managed together?',
       'Yes. We can design a coordinated workflow for referrals, room or bed availability, bookings, stay extensions, checkouts and daily reconciliation, with access appropriate to each staff role.'],
      ['Can you organise caseworker notes, case references and reporting?',
       'Yes. We can connect authorised caseworker updates, time-stamped notes, references and configurable reports. The exact fields, reporting formats and permissions are agreed with your team.'],
      ['How long does a new solution usually take?',
       'A focused automation or tailored system may take approximately one to five weeks, depending on complexity, integrations, testing and the information your team can provide. We discuss realistic timing once we see your workflow.'],
      ['How soon could our team notice a difference?',
       'You can begin seeing productivity improvements as soon as the live workflow replaces repetitive steps. The amount saved depends on how your team currently works and how the solution is adopted.']
    ]
  },
  {
    id: 'excel', label: 'Excel automation',
    items: [
      ['Can you automate our Excel spreadsheets, Google Sheets or Forms?',
       'Yes. We can streamline repeated data entry, calculations, submissions, approvals, follow-ups and reporting, often while keeping familiar steps that your team already uses.'],
      ['Do we need to stop using Excel altogether?',
       'Not necessarily. We assess what is working first. Some processes benefit from a simple automation within your existing tools, while others are better managed in one tailored system.'],
      ['Can compliance and management reporting be prepared faster?',
       'Yes. Where data can be structured and validated, reports can be generated consistently without rebuilding the same spreadsheet each time. Outputs still need appropriate review against your organisation’s reporting requirements.'],
      ['Will we be able to download reports for accounting or internal use?',
       'Where required, we can configure CSV or Excel exports and suitable reporting formats, subject to the data and integrations available.'],
      ['What sorts of reporting savings have you seen?',
       'Examples from selected client workflows include a two-hour report reduced to five minutes, and a 30-minute task reduced to under one minute. These are specific examples, not a guaranteed outcome for every service.'],
      ['We do not know what to automate first. Can you help?',
       'Yes. In the complimentary 30-minute session, show us a recurring task or walk us through the steps. We can help identify where automation would be most useful and where it may not be worthwhile.']
    ]
  },
  {
    id: 'websites', label: 'Websites',
    items: [
      ['Can BPA Solutions improve or rebuild our website?',
       'Yes. We design and improve accessible, mobile-friendly websites that help visitors understand your service, find the right information and contact the right team.'],
      ['Can a website connect to our enquiry and operational processes?',
       'Often, yes. We can connect suitable forms and notifications to approved workflows, depending on your existing systems, data protection requirements and available integrations.'],
      ['Will our site work well on phones and tablets?',
       'Responsive mobile and tablet layouts are part of our design and testing approach, including readable text, touch-friendly controls and clear navigation.'],
      ['Do you only offer websites, or can you also automate what happens afterwards?',
       'We can do both. A website can be a starting point, and appropriate enquiries, reminders or administrative steps can be automated separately where the workflow supports it.'],
      ['Will our team need to manage a complex new system?',
       'Not by default. We aim for clear editing and straightforward processes, while keeping existing tools where practical. Any required handover or ongoing support is discussed during scoping.'],
      ['How long might a website or connected workflow take?',
       'Many focused builds take approximately one to five weeks, but timing depends on content readiness, design scope, approvals, integrations and testing. We will outline the practical next steps after reviewing your needs.']
    ]
  }
];